import { ajax } from '@/plugins/ajax'

export default {
  namespaced: true,
  state: {
    list: [],
    loading: false
  },
  getters: {
    list: (state) => state.list
  },
  actions: {
    fetchNoSkip({ commit }, id) {
      commit('setLoading', true);
      return new Promise((resolve, reject) => {
        ajax.get('/Sales/api/OrdersQuery/partyInfo/' + id + '?Take=500&Skip=0').then(r => {
          commit('setList', r.data.data);
          commit('setLoading', false);
          resolve(r.data)
        }).catch(e => reject(e))
      })
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    },
    setLoading(state, value) {
      state.loading = value;
    }
  }
}
